import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { routesData } from '../resources/routes.constant';

/** Pass untouched request through to the next request handler. */
@Injectable()
export class HandleErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      retry(1),
      catchError((error) => {
        if ([401, 0].includes(error.status)) {
          let headerToken: boolean = false;
          req.headers['headers'].forEach((value: any, index: any) => {
            if (index === 'authorization-token') {
              headerToken = true;
            }
          });

          if (headerToken && error.status === 401) {
            this.router.navigate([routesData.ERRORS.TIME_ERROR.redirectPath]);
            return throwError(new Error('Unauthorized'));
          } else {
            // eslint-disable-next-line no-console
            console.error(error);
            return throwError(error);
          }
        } else {
          // eslint-disable-next-line no-console
          console.error(error);
          return throwError(error);
        }
      })
    );
  }
}
